export default "__VITE_ASSET__BMwX9r9T__"